export default /* css */ `
:host {
	--oc-font-family: 'Ariana Pro', sans-serif;

	--jockey-club-cheltenham-black-color: #000;
	--jockey-club-cheltenham-blue-color: #26334e;
	--jockey-club-cheltenham-pearl-color: #ede2C9;
	--jockey-club-cheltenham-pastel-red-color: #ff6d64;
	--jockey-club-cheltenham-white-color: #fff;

	--oc-bg-grey-light: #eaeae9;
	--oc-border: #e5e5e5;
	--oc-box-shadow: #dcdcdc;
	--oc-line-secondary: #f2f2f2;
	--oc-primary-blue: #033954;
	--oc-primary-white: #fff;
	--oc-text-body: #20242e;
	--oc-text-subtext: #9d9da3;

	--ogm-grizzlies: #9dafbd;
	--ogm-pelicans: var(--jockey-club-cheltenham-blue-color);
	--ogm-seahawks-disabled: #1ed56090;
	--ogm-seahawks: #1ed560;
	--ogm-timberwolves: #00182e;
	--ogm-white: #fff;

	--ogm-title-color-1: var(--jockey-club-cheltenham-pearl-color);
	--ogm-grid-best-odds-text-color: var(--jockey-club-cheltenham-white-color);
	--ogm-grid-compare-color: var(--jockey-club-cheltenham-blue-color);
	--ogm-grid-compare-bg-color: var(--jockey-club-pastel-red-color);
	--ogm-grid-see-all-color: var(--jockey-club-cheltenham-blue-color);
}`;
